import React, { useState, useEffect } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default function SchoolLeavingCertificate() {
  const storedSessionId = localStorage.getItem("currentSessionId");
  const [selectedSession] = useState(storedSessionId || "");

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);

  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [fatherName, setFatherName] = useState("");  // Manually editable father's name
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [reason, setReason] = useState("");
  const [template, setTemplate] = useState("Template1");

  const [headingFontFamily, setHeadingFontFamily] = useState("Times New Roman");
  const [headingFontSize, setHeadingFontSize] = useState(30);
  const [headingFontColor, setHeadingFontColor] = useState("#1e3a8a");

  const [bodyFontFamily, setBodyFontFamily] = useState("Times New Roman");
  const [bodyFontSize, setBodyFontSize] = useState(18);
  const [bodyFontColor, setBodyFontColor] = useState("#000000");
  const [textAlign, setTextAlign] = useState("center");

  const [editableContent, setEditableContent] = useState(
    "This is to certify that the above-mentioned individual has shown excellent moral behavior, discipline, and commendable character. The conduct of the student has been exemplary throughout the period."
  );

  const labelStyle = "block font-semibold text-black text-[18px] mb-2";
  const inputStyle =
    "w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm bg-white text-gray-800 text-[14px] placeholder:text-[14px] focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  // ================== Fetch Classes & Sections based on session ==================
  useEffect(() => {
    if (!selectedSession) return;
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${selectedSession}`)
      .then((res) => setClasses(res.data))
      .catch((err) => console.error("Error fetching classes:", err));
  }, [selectedSession]);

  // Fetch Sections when class changes
  useEffect(() => {
    if (!className) {
      setSections([]);
      setSectionName("");
      return;
    }
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/sections/${encodeURIComponent(
          className
        )}/getSectionsByClassName?sessionId=${selectedSession}`
      )
      .then((res) => setSections(res.data))
      .catch((err) => console.error("Error fetching sections:", err));
  }, [className, selectedSession]);

  // Fetch Students when class or section changes
  useEffect(() => {
    if (!className || !sectionName) {
      setStudents([]);
      return;
    }
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
        params: {
          class: className,
          section: sectionName,
          sessionId: selectedSession,
          status: "active",
        },
      })
      .then((res) => {
        setStudents(res.data);
      })
      .catch((err) => console.error("Error fetching students:", err));
  }, [className, sectionName, selectedSession]);

  // ================== Update Student Info ==================
  useEffect(() => {
    if (!studentId) return;

    const selectedStudent = students.find((s) => s._id === studentId);

    if (selectedStudent) {
      setStudentName(`${selectedStudent.firstName} ${selectedStudent.lastName}`);
    }
  }, [studentId, students]);

const handleSaveCertificate = async () => {
  try {
    const certificateElement = document.getElementById("certificate-preview");
    const canvas = await html2canvas(certificateElement, { scale: 2, useCORS: true });
    const imgDataUrl = canvas.toDataURL("image/png");

    const byteString = atob(imgDataUrl.split(',')[1]);
    const mimeString = imgDataUrl.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });

    const formData = new FormData();
    formData.append("file", blob, "certificate.png"); // MUST match backend multer field
    formData.append("studentId", studentId);
    formData.append("studentName", studentName);
    formData.append("fatherName", fatherName);
    formData.append("className", className);
    formData.append("sectionName", sectionName);
    formData.append("reason", editableContent);
    formData.append("template", template);
    formData.append("headingFontFamily", headingFontFamily);
    formData.append("headingFontSize", headingFontSize);
    formData.append("headingFontColor", headingFontColor);
    formData.append("bodyFontFamily", bodyFontFamily);
    formData.append("bodyFontSize", bodyFontSize);
    formData.append("bodyFontColor", bodyFontColor);
    formData.append("textAlign", textAlign);
    formData.append("date", date);
    formData.append("sessionId", selectedSession);
    formData.append("etime", new Date().toISOString());
    formData.append("certificateType","SchoolLeaving")
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/certificates/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    alert("Certificate saved successfully!");
  } catch (err) {
    console.error("Error saving certificate:", err.response?.data || err);
    alert("Failed to save certificate.");
  }
};


    

  // ================== PDF Download ==================
  const handleDownloadPDF = async () => {
    const certificateElement = document.getElementById("certificate-preview");
    const canvas = await html2canvas(certificateElement, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
    pdf.save("school_leaving_certificate.pdf");
  };

  // ================== Templates ==================
  const Template1 = () => (
    <div className="p-10 bg-white shadow-xl w-full border-[12px] border-[#d4af37] rounded-xl">
      <div className="border-[4px] border-blue-900 p-10 rounded-xl text-center">
        <h1
          style={{ fontFamily: headingFontFamily, fontSize: headingFontSize, color: headingFontColor, textAlign }}
          className="text-3xl font-bold"
        >
          School Leaving Certificate
        </h1>

        <p className="mt-4 text-[18px] leading-[30px] text-gray-800">This is to certify that</p>

        <h2
          style={{
            fontFamily: headingFontFamily,
            fontSize: headingFontSize - 4,
            color: headingFontColor,
            textAlign,
          }}
          className="text-3xl font-semibold mt-2 underline decoration-blue-900"
        >
          {studentName || "Name Surname"}
        </h2>

        <p className="mt-3">S/D of {fatherName || "__________"}</p>

        <p className="mt-3">
          was a student of Class <strong>{className || "__"}</strong>, Section <strong>{sectionName || "__"}</strong>.
        </p>

        <p className="mt-4 font-semibold">Reason for Leaving:</p>
        <div
          contentEditable
          suppressContentEditableWarning={true}
          onInput={(e) => setEditableContent(e.currentTarget.textContent)}
          className="italic mt-3"
          style={{ fontFamily: bodyFontFamily, fontSize: bodyFontSize, color: bodyFontColor, textAlign }}
        >
          {editableContent || "__________"}
        </div>

        <p className="mt-6">Issued on: {date}</p>

        <div className="mt-12">
          <p className="border-t-2 border-gray-700 w-64 mx-auto"></p>
          <p className="mt-2">Authorized Signature</p>
        </div>
      </div>
    </div>
  );

  // ================= TEMPLATE 2 =================
  const Template2 = () => (
    <div className="relative bg-white p-12 shadow-2xl rounded-xl border-[14px] border-[#1e3a8a] overflow-hidden text-center">
      <div className="absolute left-0 top-0 h-full w-6 bg-[#1e3a8a]"></div>
      <div className="absolute right-0 top-0 h-full w-6 bg-[#fbbf24]"></div>

      <h1
        className="text-5xl font-extrabold tracking-wide"
        style={{
          fontFamily: headingFontFamily,
          fontSize: headingFontSize,
          color: headingFontColor,
          textAlign,
        }}
      >
        SCHOOL LEAVING CERTIFICATE
      </h1>

      <p className="mt-4 text-lg text-gray-700">This is to certify that</p>

      <h2
        className="text-4xl font-bold mt-4 text-[#f59e0b] underline decoration-[#1e3a8a] underline-offset-4"
        style={{
          fontFamily: headingFontFamily,
          fontSize: headingFontSize - 4,
          color: headingFontColor,
          textAlign,
        }}
      >
        {studentName || "Name Surname"}
      </h2>

      <p className="mt-4">S/D of {fatherName || "____"}</p>

      <p className="mt-4 text-gray-700">
        Studied in Class <b>{className || "__"}</b>, Section{" "}
        <b>{sectionName || "__"}</b>.
      </p>

      <p className="mt-6 font-semibold text-gray-800">Reason for Leaving:</p>
      <div
        contentEditable
        suppressContentEditableWarning={true}
        onInput={(e) => setEditableContent(e.currentTarget.textContent)}
        className="italic mt-3"
        style={{
          fontFamily: bodyFontFamily,
          fontSize: bodyFontSize,
          color: bodyFontColor,
          textAlign,
        }}
      >
        {editableContent || "____"}
      </div>

      <p className="mt-8 text-gray-700">Issued on: {date}</p>

      <div className="mt-12">
        <p className="border-t-2 border-gray-700 w-60 mx-auto"></p>
        <p className="mt-2 font-semibold">Authorized Signature</p>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-4 bg-[#1e3a8a]"></div>
    </div>
  );

  // ================= TEMPLATE 3 =================
  const Template3 = () => (
    <div className="relative bg-white p-10 shadow-2xl rounded-xl border-[10px] border-[#a16b3d] overflow-hidden">
      <div className="relative z-10 text-center">
        <h1
          className="text-4xl font-bold tracking-wide uppercase"
          style={{
            fontFamily: headingFontFamily,
            fontSize: headingFontSize,
            color: headingFontColor,
            textAlign,
          }}
        >
          School Leaving Certificate
        </h1>

        <p
          className="mt-2 text-gray-600 tracking-widest text-sm uppercase"
          style={{
            fontFamily: bodyFontFamily,
            fontSize: bodyFontSize - 2,
            color: bodyFontColor,
            textAlign,
          }}
        >
          This certifies that
        </p>

        <h2
          className="text-5xl font-extrabold mt-6"
          style={{
            fontFamily: headingFontFamily,
            fontSize: headingFontSize - 4,
            color: headingFontColor,
            textAlign,
          }}
        >
          {studentName || "Name Surname"}
        </h2>

        <p className="mt-4">S/D of {fatherName || "____"}</p>

        <p className="mt-4 text-lg">
          Studied in Class <b>{className || "__"}</b>, Section{" "}
          <b>{sectionName || "__"}</b>.
        </p>

        <p className="mt-6 font-semibold">Reason for Leaving:</p>
        <div
          contentEditable
          suppressContentEditableWarning={true}
          onInput={(e) => setEditableContent(e.currentTarget.textContent)}
          className="italic mt-3"
          style={{
            fontFamily: bodyFontFamily,
            fontSize: bodyFontSize,
            color: bodyFontColor,
            textAlign,
          }}
        >
          {editableContent || "____"}
        </div>

        <p className="mt-8">Issued on: {date}</p>

        <div className="flex justify-center mt-12">
          <p className="border-t-2 border-gray-700 w-48 mx-auto"></p>
          <p className="mt-2 font-semibold">Authorized Signature</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="p-6 bg-white shadow-md rounded-lg w-full mx-auto max-w-screen-xl">
      {/* FORM */}
      <form className="space-y-5 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Class */}
          <div>
            <label className={labelStyle}>Class</label>
            <select className={inputStyle} value={className} onChange={(e) => setClassName(e.target.value)}>
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option key={cls._id} value={cls.className}>
                  {cls.className}
                </option>
              ))}
            </select>
          </div>

          {/* Section */}
          <div>
            <label className={labelStyle}>Section</label>
            <select className={inputStyle} value={sectionName} onChange={(e) => setSectionName(e.target.value)}>
              <option value="">Select Section</option>
              {sections.map((sec) => (
                <option key={sec._id} value={sec.sectionName}>
                  {sec.sectionName}
                </option>
              ))}
            </select>
          </div>

          {/* Student */}
          <div className="md:col-span-2">
            <label className={labelStyle}>Select Student</label>
            <select className={inputStyle} value={studentId} onChange={(e) => setStudentId(e.target.value)}>
              <option value="">Select Student</option>
              {students.length > 0 ? (
                students.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.firstName} {s.lastName}
                  </option>
                ))
              ) : (
                <option>No students found</option>
              )}
            </select>
          </div>

          {/* Father's Name */}
          <div className="md:col-span-2">
            <label className={labelStyle}>Father's Name</label>
            <input
              className={inputStyle}
              type="text"
              value={fatherName}
              onChange={(e) => setFatherName(e.target.value)}
              placeholder="Enter Father's Name"
            />
          </div>

          {/* Reason */}
          <div className="md:col-span-2">
            <label className={labelStyle}>Reason</label>
            <textarea className={inputStyle} rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
          </div>

          {/* Template Selector */}
          <div className="md:col-span-2">
            <label className={labelStyle}>Select Template</label>
            <select className={inputStyle} value={template} onChange={(e) => setTemplate(e.target.value)}>
              <option value="Template1">Template 1</option>
              <option value="Template2">Template 2</option>
              <option value="Template3">Template 3</option>
            </select>
          </div>
        </div>
      </form>

      {/* Certificate Preview */}
      <div id="certificate-preview" className="mt-10">
        {template === "Template1" && <Template1 />}
        {template === "Template2" && <Template2 />}
        {template === "Template3" && <Template3 />}
      </div>

      {/* Buttons */}
      <div className="text-center mt-8 flex gap-4 justify-center">
        <button
          onClick={handleDownloadPDF}
          className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg shadow-lg hover:bg-green-700"
        >
          Download PDF
        </button>
        <button
          onClick={handleSaveCertificate}
          className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-lg hover:bg-blue-700"
        >
          Save Certificate
        </button>
      </div>
    </div>
  );
}
